var _style, _path, _path2, _path3, _path4, _ellipse, _path5, _path6, _path7, _line, _path8, _path9, _ellipse2, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockIconEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{display:none;fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:#F3F3F3;}\n\t.st5{fill:url(#SVGID_5_);}\n\t.st6{fill:#A3A3A3;}\n\t.st7{fill:url(#SVGID_6_);}\n\t.st8{fill:none;stroke:#A4A4A4;stroke-width:1.9486;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st9{fill:url(#SVGID_7_);}\n\t.st10{fill:url(#SVGID_8_);}\n\t.st11{fill:#A4A4A4;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.4132,
    y1: 9.6406,
    x2: 50.2843,
    y2: 24.5778,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#525252",
      stopOpacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.5,75.4c-2.7,1.6-7.2,1.7-9.9,0.1L19.2,62c-2.7-1.6-2.8-4.2,0-5.8l3-1.8c2.7-1.6,7.2-1.7,9.9-0.1l23.3,13.4 c2.7,1.6,2.8,4.2,0,5.8L52.5,75.4z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.6822,
    y1: 7.2866,
    x2: 45.6757,
    y2: 19.4076,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#525252",
      stopOpacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.8,78c-2.6,1.5-6.9,1.4-9.7-0.2L19.8,64.9c-2.7-1.6-2.9-4.1-0.3-5.6c2.6-1.5,6.9-1.4,9.7,0.2l21.3,12.8 C53.3,74,53.4,76.5,50.8,78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.1547,
    y1: 24.3943,
    x2: 31.2778,
    y2: 77.8725,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#B8B8B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#ADADAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#A6A6A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#A4A4A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3F3F3"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.5,43.5c0-13.9-9.8-30.8-21.8-37.8c-6.1-3.5-11.6-3.8-15.6-1.5l0,0l-10.5,6.1l4.2,7.5c0,0.2,0,0.3,0,0.5 c0,13.7,9.5,30.3,21.3,37.5l4.7,8.4l11.2-6.5l0,0C66.1,55.4,68.5,50.5,68.5,43.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.858,
    y1: 44.7728,
    x2: 57.5143,
    y2: 44.7728,
    gradientTransform: "matrix(1 0 0 -1 4.900208e-03 82.006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEBEBE"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20.3,10.5c8.5-4.9,22.3,3.1,30.9,17.8s8.5,30.7,0,35.6c-8.5,4.9-22.3-3.1-30.9-17.8S11.7,15.4,20.3,10.5z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -13.8349 22.8338)",
    className: "st4",
    cx: 35.7,
    cy: 37.2,
    rx: 16.6,
    ry: 28.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.8928,
    y1: 17.8602,
    x2: 75.1678,
    y2: 59.9028,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3A3A3"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M50.9,64.1L51,64L50.9,64.1L50.9,64.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M51.2,63.9L51,64L51.2,63.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.3942,
    y1: 44.2995,
    x2: 50.7808,
    y2: 44.2995,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3A3A3"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M49.7,62c-3.4,1.1-7.7,0.4-12.4-2.3C26,53.3,16.9,37.6,16.9,24.6c0-5.8,1.8-10,4.9-12.4 c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0.1-0.3,0.1-0.4,0.2c-3.9,2-6.4,6.6-6.4,13.4c0,12.9,9.1,28.7,20.3,35.1c5.5,3.2,10.4,3.5,14.1,1.6 c0.3-0.2,0.7-0.4,1-0.6C50.4,61.8,50.1,61.9,49.7,62z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 35.7,
    y1: 37.2,
    x2: 35.7,
    y2: 19.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.8506,
    y1: 17.9465,
    x2: 51.0206,
    y2: 17.9465,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3A3A3"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M50.9,64.1L50.9,64.1L51,64L50.9,64.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.4124,
    y1: 44.2995,
    x2: 50.799,
    y2: 44.2995,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCDCDC"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M37.3,59.8C26.1,53.3,17,37.6,17,24.6c0-5.8,1.8-10,4.9-12.4c0.1-0.1,0.2-0.2,0.3-0.3 c-0.1,0.1-0.3,0.1-0.4,0.2c-3.9,2-6.4,6.6-6.4,13.4c0,12.9,9.1,28.7,20.3,35.1c5.5,3.2,10.4,3.5,14.1,1.6c0.3-0.2,0.7-0.4,1-0.6 c-0.4,0.2-0.7,0.3-1.1,0.4C46.2,63.1,41.9,62.5,37.3,59.8z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -13.8349 22.8338)",
    className: "st11",
    cx: 35.7,
    cy: 37.2,
    rx: 1.7,
    ry: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 35.7,
    y1: 37.2,
    x2: 45,
    y2: 47.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIconEmpty);
export default __webpack_public_path__ + "static/media/clock_icon_empty.bb87270d93026a1d3e652c860afdc380.svg";
export { ForwardRef as ReactComponent };